/* esm.sh - @noble/hashes@1.8.0/ripemd160 */
import{RIPEMD160 as r,ripemd160 as o}from"@noble/hashes/legacy";var e=r,m=o;export{e as RIPEMD160,m as ripemd160};
//# sourceMappingURL=ripemd160.mjs.map